export default {
    filterBar: {
        sideFilterAria: 'Side filter',
        countryFilterAria: 'Country filter',
        allCountriesAria: 'Show contracts from all countries',
        hrOnlyAria: 'Show HR contracts only',
        siOnlyAria: 'Show SI contracts only',
    },
}
